// import _ from "lodash"

export default class NewOrderSlotsCalendar extends React.Component {
  get _minDate() {
    const firstStock = this.props.slots[0]
    return firstStock && firstStock.start_date
  }

  get _maxDate() {
    let date = new Date;
    date.setMonth(date.getMonth() + 25);
    date.setDate(0);
    return date;
  }

  componentDidMount() {
    this._initPikaday()
    this.handleInitialSlotsLoad();
  }

  componentDidUpdate(prevProps) {
    if (this.pikaday) {
      this.pikaday.setMinDate(new Date(this._minDate));
      this.pikaday.setMaxDate(new Date(this._maxDate));

      if (this.pikaday._o.numberOfMonths !== this.props.numberOfMonths) {
        this.pikaday._o.numberOfMonths = this.props.numberOfMonths
        this.pikaday.adjustCalendars()
      }

      if (this.props.selectedSlot !== prevProps.selectedSlot) {
        if (this.props.selectedSlot && this.props.selectedSlot.start_date) {
          this.pikaday.setStartRange(new Date(this.props.selectedSlot.start_date))
          this.pikaday.setEndRange(new Date(this.props.selectedSlot.end_date))
          this.pikaday.setDate(new Date(this.props.selectedSlot.start_date))
        } else {
          this.pikaday.setStartRange(null)
          this.pikaday.setEndRange(null)
          this.pikaday.setDate(null)
        }

        this.pikaday.draw(true)
      }

      if (this.props.slots.length == 0 && this.props.lastSlotSelectDate < moment().add(24, "month").format(moment.RUBY_DATE_FORMAT) && !this.props.slotsLoading) {
        const startDate = moment().format(moment.RUBY_DATE_FORMAT);
        const endDate = moment(this.props.lastSlotSelectDate).add(this.props.numberOfMonths, "months").format(moment.RUBY_DATE_FORMAT);
        this.props.onSlotsLoad(startDate, endDate);
        
        const calendarDate = new Date(this.props.lastSlotSelectDate)
        this.pikaday.gotoDate(calendarDate);
      }
    }
  }

  componentWillUnmount() {
    this._closeDayPopover();
  }

  handleInitialSlotsLoad() {
    if (this.props.slots.length == 0) {
      const firstCalendar = this.pikaday.calendars[0];
      const lastCalendar = this.pikaday.calendars[this.pikaday.calendars.length - 1];
      const startDate = moment({ month: firstCalendar.month, year: firstCalendar.year }).subtract(1, "month").endOf("month").format(moment.RUBY_DATE_FORMAT);
      let endDate = moment({ month: lastCalendar.month, year: lastCalendar.year }).add(1, "month").format(moment.RUBY_DATE_FORMAT);

      if (firstCalendar == lastCalendar) {
        endDate = moment(endDate).add(1, "month").format(moment.RUBY_DATE_FORMAT);
      }

      const selectedSlotId = this.props.selectedSlotId
      this.props.onInitialSlotsLoad(startDate, endDate, selectedSlotId);
    }
  }

  handleNextMonthSelect() {
    const calendar = this.pikaday.calendars[this.pikaday.calendars.length - 1];
    const startDate = moment({ month: calendar.month, year: calendar.year }).endOf("month").format(moment.RUBY_DATE_FORMAT);
    const endDate = moment({ month: calendar.month, year: calendar.year }).add(2, "months").format(moment.RUBY_DATE_FORMAT);
    if (this.props.lastSlotSelectDate < endDate) {
      this.props.onSlotsLoad(startDate, endDate);
    }
  }

  _initPikaday() {
    this.pikaday = new Pikaday({
      bound: false,
      container: this._pikadayContainer,
      minDate: new Date(this._minDate),
      maxDate: new Date(this._maxDate),
      defaultDate: new Date(this._minDate),
      numberOfMonths: this.props.numberOfMonths,

      customDayClassFn: day => {
        const dateKey = moment(day).format(moment.RUBY_DATE_FORMAT)
        const slots = this.props.slots.filter(slot => slot.start_date === dateKey)
        const classes = []
        if (slots.find(slot => slot.stock_available)) {
          classes.push("is-available")
          if (slots.find(slot => slot.stock_available && slot.display_as_confirmed)) {
            classes.push("is-confirmed")
          }
        } else if (slots.length > 0) {
          classes.push("is-busy")
        }
        return classes.join(" ")
      },

      disableDayFn: day => {
        const dateKey = moment(day).format(moment.RUBY_DATE_FORMAT)
        const slots = this.props.slots.filter(slot => slot.start_date === dateKey)
        // if (this.props.selectedSlot && dateKey === this.props.selectedSlot.start_date) {
        //   return false
        // }
        return !slots.find(slot => slot.stock_available)
      },

      // onAdjustCalendars: () => {
      //   return this.emit("pikaday.adjustCalendars")
      // },

      _onMouseDown: event => {
        event = event || window.event;
        const target = event.target || event.srcElement;
        if (!this.pikaday._v) { return; }
        if (!target) { return; }

        if (!$(target).hasClass('is-disabled')) {
          if ($(target).hasClass('pika-day')) {
            this._selectDayElement(target);
          } else if ($(target).closest(".pika-prev").length) {
            this.pikaday.prevMonth();
          } else if ($(target).closest(".pika-next").length) {
            this.handleNextMonthSelect()
            this.pikaday.nextMonth();
          }
        }

        // if this is touch event, prevent mouse events emulation
        if (event.preventDefault) {
          return event.preventDefault();
        } else {
          event.returnValue = false;
          return false;
        }
      }
    });
  }

  // Selects the given date on the calendar.
  _selectDayElement(dayElement) {
    const date = new Date(
      dayElement.getAttribute("data-pika-year"),
      dayElement.getAttribute("data-pika-month"),
      dayElement.getAttribute("data-pika-day")
    );
    const dateMoment = moment(date);
    const dateKey = dateMoment.format(moment.RUBY_DATE_FORMAT);

    if (this.props.selectedSlot && dateKey === this.props.selectedSlot.start_date) {
      this._closeDayPopover()
      this.props.onSlotSelect(null)
    } else {
      this._openDayPopover(dayElement)
    }
  }

  _closeDayPopover() {
    if (this._dayPopover) {
      this._dayPopover && this._dayPopover.destroy()
      delete this._dayPopover
    }
  }

  // Opens the popover with list of product variants on clicked date.
  _openDayPopover(dayElement) {
    if ($(dayElement).parent().hasClass("is-focused")) {
      this._closeDayPopover()
      return
    }

    this._closeDayPopover()

    const date = new Date(
      dayElement.getAttribute("data-pika-year"),
      dayElement.getAttribute("data-pika-month"),
      dayElement.getAttribute("data-pika-day")
    );
    const dateMoment = moment(date);
    const dateKey = dateMoment.format(moment.RUBY_DATE_FORMAT);
    const slots = this.props.slots
      .filter(slot => slot.start_date === dateKey)
      .filter(slot => slot.stock_available)
      .map(slot => {
        return {
          ...slot,
          product_variant: this.props.product.product_variants.find(pv => pv.id == slot.product_variant_id)
        }
      })

    if (slots.length === 1) {
      return this.props.onSlotSelect(slots[0])
    }

    const popoverContent = (
      <ul className="choose-order-target">
        {slots.map(slot => (
          <li
            className="item item-order-target item-product-variant"
            data-slot-id={`${slot.id}`}
            key={slot.id}>
            <div className="item-radio"><input type="radio" /></div>
            <div className="item-content">
              <div className="item-title-row">
                <div className="item-name">
                  {slot.product_variant.name}
                </div>
              </div>

              {!!slot.includes_time && (
                <div className="item-time">
                  {st.formatTimeRange(slot.starts_at, slot.ends_at, { includeDate: false })}
                </div>
              )}

              <div className="item-metas">
                {I18n.t(`fe.reservation_calendar.last_stocks`)}
              </div>
            </div>
          </li>
        ))}
      </ul>
    );

    $(dayElement).popover({
      container: "body",
      html: true,
      placement: "auto left",
      title: `${moment(date).format("DD MMMM YYYY")} <a class="popover-close">&times;</a>`,
      content: ReactDOMServer.renderToStaticMarkup(popoverContent),
      trigger: "manual"
    });
    const popover = this._dayPopover = $(dayElement).data("bs.popover");

    $(dayElement).one("shown.bs.popover", () =>
      popover.tip().find('[data-toggle="tooltip"]').tooltip({
        container: 'body',
        html: true
      })
    );

    popover.tip().addClass("reservation-calendar-choose-order-target-popover");
    popover.tip().on("click", ".popover-close", () => popover.destroy());

    popover.tip().on("click", ".item-order-target", event => {
      const dayElement = $(event.target).closest(".item-order-target")[0];
      const slotId = +dayElement.getAttribute("data-slot-id");
      const slot = slots.find(slot => slot.id === slotId);
      this.props.onSlotSelect(slot);
      popover.destroy();
    });

    $(dayElement).parent().addClass("is-focused");
    $(dayElement).one("hide.bs.popover", () => $(dayElement).parent().removeClass("is-focused"));

    popover.show();
  }

  render() {
    return (
      <div
        ref={ref => this._pikadayContainer = ref}
        className={`reservation_calendar reservation_calendar--start_date`}>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/NewOrderSlotsCalendar.jsx